module.exports = __webpack_public_path__ + "img/pic1.69dae430.png";